import React from "react";
import "../css/dashboard.css";
import "../css/client.css";
import ClientProfile from "../component/ClientProfile";
import TopTitleBanner from "../component/TopTitleBanner";
import { useParams } from "react-router-dom";

export default function ClientContent(props) {
  const { id } = useParams();
  const clientId = props.clientId || id;

  return (
    <div className="right-container">
      <TopTitleBanner title={"Client profile"} clientId={clientId} />
      <ClientProfile
        clientId={clientId}
        // clientId={props.clientId}
      />
    </div>
  );
}
